import { TOAST_TYPE } from "../../constants";

const prefix = "sys/";
export const _sharedActionsConstantsSystem = {
  LOADING: prefix + "loading",
  TOAST: prefix + "toast",
  TOAST_SUCCESS: prefix + "toast-success",
  SET_IS_ONLINE: prefix + "set-is-online",
  SET_IS_LOGIN: prefix + "set-is-login",
  SET_USER_INFO: prefix + "set-user-info",
  SET_TOP_PANEL_VISIBILITY: prefix + "set-topPanel-visibility",
  UPDATE_DATA_ACQUISITION_STATUS: prefix + "update-data-acquisition-status",
  SET_AVATAR_LAST_UPDATE_TIMESTAMP: prefix + "set-avatar-last-update-timestamp",
  UPLOAD_USER_AVATAR: prefix + "upload-user-avatar",
  DELETE_USER_AVATAR: prefix + "delete-user-avatar",
};

export const _sharedActionsSystem = {
  updateDataAcquisitionStatus: (data) => ({
    type: _sharedActionsConstantsSystem.UPDATE_DATA_ACQUISITION_STATUS,
    data,
  }),
  loading: (loadingId, forceRemove = false, forceAdd = false) => ({
    type: _sharedActionsConstantsSystem.LOADING,
    data: { loadingId, forceRemove, forceAdd },
  }),
  toast: (message, type = TOAST_TYPE.notify) => ({
    type: _sharedActionsConstantsSystem.TOAST,
    data: { message, type },
  }),
  toastSuccess: (message) => ({
    type: _sharedActionsConstantsSystem.TOAST_SUCCESS,
    data: message,
  }),
  setIsOnline: (flag) => ({
    type: _sharedActionsConstantsSystem.SET_IS_ONLINE,
    data: flag,
  }),
  setIsLogin: (flag, isFetchInitLoad) => {
    return ({
      type: _sharedActionsConstantsSystem.SET_IS_LOGIN,
      data: flag,
      isFetchInitLoad, // is not in the {data} to not re-write each case.
    });
  },
  setUserInfo: (userInfo) => ({
    type: _sharedActionsConstantsSystem.SET_USER_INFO,
    data: userInfo,
  }),
  setAvatarLastUpdateTimestamp: (timestamp) => ({
    type: _sharedActionsConstantsSystem.SET_AVATAR_LAST_UPDATE_TIMESTAMP,
    data: timestamp,
  }),
  uploadUserAvatar: (avatar) => ({
    type: _sharedActionsConstantsSystem.UPLOAD_USER_AVATAR,
    data: avatar,
  }),
  deleteUserAvatar: () => ({
    type: _sharedActionsConstantsSystem.DELETE_USER_AVATAR,
  }),
  setTopPanelVisibility: (flag) => {
    return ({
      type: _sharedActionsConstantsSystem.SET_TOP_PANEL_VISIBILITY,
      data: flag,
    });
  },
};
